import { Col, Divider, Image, message, Row } from 'antd'
import { Button } from 'antd'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { postCheck } from '../../api/api'
import './index.css'

export default function PostDetail() {
  const location = useLocation()
  const [info, setInfo] = useState({})
  //将是否置顶转化为文字
  const switchIs = (num) => {
    switch (num) {
      case 0:
        return '否'
        break
      case 1:
        return '是'
        break
      default:
        break
    }
  }
  const switchPostStatus = (num) => {
    switch (num) {
      case 0:
        return '已结束'
        break
      case 1:
        return '正常发布'
        break
      default:
        break
    }
  }

  const switchAuditStatus = (num) => {
    switch (num) {
      case 1:
        return '待审核'
        break
      case 2:
        return '审核通过'
        break
      case 3:
        return '审核不通过'
        break
      default:
        break
    }
  }

  const switchtype = (num) => {
    switch (num) {
      case 1:
        return '合租'

      case 2:
        return '转租'

      case 3:
        return '出售'

      case 4:
        return '求购'

      default:
        break
    }
  }

  const switchClassificationName = (num) => {
    switch (num) {
      case 1:
        return '厨房用品'

      case 2:
        return '生活用品'

      case 3:
        return '电子产品'

      case 4:
        return '美容美肤'

      case 5:
        return '服装配饰'

      case 6:
        return '书籍材料'

      case 7:
        return '其他'

      default:
        break
    }
  }
  const switchConditionName = (num) => {
    switch (num) {
      case 1:
        return '全新'

      case 2:
        return '微瑕'

      case 3:
        return '九成新'

      case 4:
        return '八成新'

      case 5:
        return '七成新'

      case 6:
        return '六成新'

      case 7:
        return '五成新'

      case 8:
        return '四成新'

      case 9:
        return '三成新'

      case 10:
        return '二成新'

      case 11:
        return '一成新'

      default:
        break
    }
  }

  useEffect(() => {
    const info = location.state.info
    console.log(info)
    //修改数字成文字
    info.isSticky = switchIs(info.is_sticky)
    info.isOffline = switchIs(info.is_offline)
    info.postStatus = switchPostStatus(info.post_status)
    info.typeName = switchtype(info.type)
    info.classificationName = switchClassificationName(info.classification)
    info.conditionName = switchConditionName(info.condition)
    info.createdAt = moment(info.created_at).format('YYYY-MM-DD HH:mm:ss')
    info.authorCreatedAt = moment(info.author_created_at).format(
      'YYYY-MM-DD HH:mm:ss'
    )
    info.images.unshift(info.image)
    if(info.plate_id === 1){//为转租合租时将物品类型，是否面交，新旧程度置为空
          info.classificationName = undefined
          info.isOffline = undefined
          info.conditionName = undefined
    }
    setInfo(info)
  }, [])

  const navigate = useNavigate()

  const checkPass = () => {
    const params = {
      audit_status: 2,
      thread_ids: [info.id],
    }
    postCheck(params)
      .then((res) => {
        message.success('审核通过！')
      })
      .catch((err) => console.log(err))

    navigate('/postManage', { replace: true })
  }

  const checkNoPass = () => {
    const params = {
      audit_status: 3,
      thread_ids: [info.id],
    }
    postCheck(params)
      .then((res) => {
        message.success('审核不通过！')
      })
      .catch((err) => console.log(err))

    navigate('/postManage', { replace: true })
  }

  const set_auditStatusSTyle = () => {
    const style = {
      ' textAlign': 'right',
      fontWeight: '1000',
      fontSize: 'x-large',
      color: 'black',
    }

    switch (info.audit_status) {
      case 1:
        style.color = 'blue'
        break
      case 2:
        style.color = 'green'
        break
      case 3:
        style.color = 'red'
        break
      default:
        break
    }
    // console.log(style);
    return style
  }

  return (
    <div className="postDetail">
      <Row>
        <Col span={21}>
          {' '}
          <p className="posttitle">帖子编号:{info.id}</p>
        </Col>
        <Col span={3}>
          {' '}
          <p style={set_auditStatusSTyle()}>
            {switchAuditStatus(info.audit_status)}
          </p>
        </Col>
      </Row>
      <div className="header">
        <Row>
          <Col className="infoTitle" span={2}>
            帖子标题:
          </Col>
          <Col span={4}>{info.title}</Col>
          <Col className="infoTitle" span={2}>
            发布状态:
          </Col>
          <Col span={4}>{info.postStatus}</Col>
          <Col className="infoTitle" span={2}>
            帖子类型:
          </Col>
          <Col span={4}>{info.typeName}</Col>
          <Col className="infoTitle" span={2}>
            新旧程度:
          </Col>
          <Col span={4}>{info.conditionName}</Col>
        </Row>
        <Row>
          <Col className="infoTitle" span={2}>
            物品类型:
          </Col>
          <Col span={4}>{info.classificationName}</Col>
          <Col className="infoTitle" span={2}>
            价格:
          </Col>
          <Col span={4}>{info.price}</Col>
          <Col className="infoTitle" span={2}>
            是否置顶:
          </Col>
          <Col span={4}>{info.isSticky}</Col>
          <Col className="infoTitle" span={2}>
            是否面交:
          </Col>
          <Col span={4}>{info.isOffline}</Col>
        </Row>
        <Row>
          {' '}
          <Col className="infoTitle" span={2}>
            联系人:
          </Col>
          <Col span={4}>{info.appellation}</Col>
          <Col className="infoTitle" span={2}>
            联系方式:
          </Col>
          <Col span={4}>{info.contact}</Col>
          <Col className="infoTitle" span={2}>
            发布时间:
          </Col>
          <Col span={6}>{info.createdAt}</Col>
        </Row>
      </div>
      <Divider />
      <p className="posttitle">简介</p>
      <div className="introduction">
        <p>{info.content}</p>
      </div>
      <Divider />
      <p className="posttitle">帖子图片</p>
      <div className="postImg">
        {info.images
          ? info.images.map((item, index) => (
              <>
                <Image width={80} height={80} src={item} />
              </>
            ))
          : null}
      </div>
      <Divider />
      <p className="posttitle">发帖人信息</p>
      <div className="postInfo">
        <Row>
          <Col className="infoTitle" span={2}>
            发帖人:
          </Col>
          <Col span={4}>{info.author}</Col>{' '}
          <Col className="infoTitle" span={3}>
            发帖人手机号:
          </Col>
          <Col span={5}>{info.phone}</Col>{' '}
          <Col className="infoTitle" span={3}>
            发帖人注册时间:
          </Col>
          <Col span={6}>{info.authorCreatedAt}</Col>
        </Row>
      </div>

      <div className="checkButton">
        <Button danger onClick={checkNoPass}>
          审核不通过
        </Button>
        <Button type="primary" onClick={checkPass}>
          审核通过
        </Button>
      </div>
    </div>
  )
}
